import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromUndertak } from "@/components/calculators/lineMappers";
import { undertakCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/undertak")({
  component: UndertakPage,
});

function UndertakPage() {
  const [area, setArea] = useState<number | "">("");
  const [bredde, setBredde] = useState<number | "">(1.5);
  const [lengde, setLengde] = useState<number | "">(50);
  const [overlapp, setOverlapp] = useState<number | "">(15);

  const r = useMemo(() => {
    if (area === "") return null;
    return undertakCalc({
      takflate_m2: Number(area),
      rull_bredde_m: bredde === "" ? undefined : Number(bredde),
      rull_lengde_m: lengde === "" ? undefined : Number(lengde),
      overlapp_pct: overlapp === "" ? undefined : Number(overlapp),
    });
  }, [area, bredde, lengde, overlapp]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Undertak" subtitle="Beregn antall ruller undertak (f.eks. bandsjekk / diffusjonsåpent)." />
      <CalcShell
        title="Inndata"
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Antall ruller", value: `${fmt(r.ruller, 0)} stk`, strong: true },
              { label: "Tape",          value: `${fmt(r.tape_m, 0)} m` },
            ]}
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Undertak`} lines={linesFromUndertak(r)} defaultLaborHours={Math.max(0, Math.round((Number(area) * 0.2) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn takflate.</div>}
      >
        <Field label="Takflate" unit="m²"><NumberInput value={area} onChange={setArea} /></Field>
        <Field label="Rull­bredde" unit="m"><NumberInput value={bredde} onChange={setBredde} /></Field>
        <Field label="Rull­lengde" unit="m"><NumberInput value={lengde} onChange={setLengde} /></Field>
        <Field label="Overlapp" unit="%"><NumberInput value={overlapp} onChange={setOverlapp} /></Field>
      </CalcShell>
    </>
  );
}
